/**
 * Configuration to turn support Retailers in selected countries
 */
export const SUPPORTED_COUNTRIES = 'SUPPORTED_COUNTRIES';
